import NewRoom from 'Components/VideoPanel/NewRoom';
import { VIDEO_SUBPATHS } from 'Constants/routing';
import { MobXProviderContext, observer } from 'mobx-react';
import * as React from 'react';
import { Navigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';

/**
 * Restricts access to the New Room page.
 *
 * Users without an active trial or a Pro package are redirected to
 * their Personal Room.
 */
const NewRoomRouteGuard: React.FC = () => {
  const { person } = React.useContext<RootStoreProps>(MobXProviderContext);

  if (!person.personAvaliableFeatures.video.enabled) {
    return <Navigate to={VIDEO_SUBPATHS.PERSONAL_ROOM} replace />;
  }

  return <NewRoom />;
};

export default observer(NewRoomRouteGuard);